export default "__VITE_ASSET__77RYB8fF__"